import React from 'react';
import { RichTextField } from 'react-admin';

import DiffFieldLayout from './DiffFieldLayout';

const TextDiffField = ({
  source,
  label,
}: {
  source: string;
  label: string;
}) => (
  <DiffFieldLayout
    label={label}
    oldElement={<RichTextField source={`${source}.oldValue`} />}
    newElement={<RichTextField source={`${source}.newValue`} />}
  />
);

export default TextDiffField;
